import React from 'react'
import DataTable from 'react-data-table-component'

export default function Activities({records, onShowGame}) {
  const columns = [
    {
        name: 'Location',
        selector: row => row.location,
        sortable: false,
    },
    {
        name: 'Time',
        selector: row => row.time,
        sortable: true,
    },
    {
        name: 'Event',
        selector: row => row.message,
        sortable: true,
    },
    {
        name: 'Reservation',
        cell: (row) => gameRow(row),
        sortable: false,
    },
    {
        name: 'Author',
        selector: row => row.author_data,
        sortable: true,
    },
  ]

  const gameRow = (row) => {
    if (!row.has_game) return

    return <a className='btn btn-default clickable' onClick={() => onShowGame(row) } id={row.game_id}>Details</a>
  }

  return <DataTable
    columns={columns}
    data={records}
    striped
  />
}
